<div class="response-ctr">
    <div class="d-flex">
        <span class="circle"></span>

        <div>
            <div>
                <label>(owner)</label>
            </div>

            <div class="mt-1">
                <label>Just now</label>  
            </div>
        </div>
    </div>

    <div class="form-ctr">
        <div>
            <label class="your-reply-lbl">
                Your reply
            </label>
        </div>

        <form [formGroup]="replyToReviewForm">
            <textarea 
                formControlName="response" 
                name="response" 
                id="response"
                type="text">
            </textarea>
        </form>

        <div [ngClass]="replyToReviewForm.controls.response.errors?.maxlength ? 'error-ctr' : 'success-ctr'">
            {{replyToReviewForm.controls.response.value?.length? replyToReviewForm.controls.response.value.length : 0}}/{{replyCharacters}}
        </div>

        <div>
            <button 
                class="btn btn-outline-primary" 
                (click)="post.emit(replyToReviewForm.controls.response.value)"
                [disabled]="!replyToReviewForm.valid"
                *ngIf="showPostBtn"
            >
                Post Reply
            </button>
            <button 
                class="btn btn-outline-primary ms-2" 
                (click)="generateReplyIfValidate()"
            >
                Generate Reply
            </button>
                <button 
                class="btn btn-outline-primary ms-2 "
                (click)="copyResponse()"
            >
                Copy
            </button>

            <button
                class="btn btn-outline-secondary ms-2"
                (click)="cancel.emit()"
            >
                Cancel
            </button>
        </div>
    </div>
</div>
